import React, { Fragment } from "react";
import PropTypes from "prop-types";

const verifyMedicareCardFailedResponse = ({ failedResponse }) => (
  <Fragment>
    {failedResponse && failedResponse.message && (
      <p>{failedResponse.message}</p>
    )}
    {failedResponse &&
      !failedResponse.message &&
      failedResponse.serviceMessage && (
        <div>
          {failedResponse.serviceMessage.map((item, index) => (
            <p key={index}>{item.reason}</p>
          ))}
        </div>
      )}
    {failedResponse && failedResponse.httpCode === "500" && (
      <p>
        {failedResponse.httpMessage || "Status Code 500. Internal Server Error"}
      </p>
    )}
    {failedResponse &&
      failedResponse.httpCode !== "500" &&
      !failedResponse.message &&
      !failedResponse.serviceMessage && (
        <p>
          Please check patient's first name, last name, date of birth, gender
          and Medicare Card Information before checking.
        </p>
      )}
  </Fragment>
);

export default verifyMedicareCardFailedResponse;

verifyMedicareCardFailedResponse.prototype = {
  failedResponse: PropTypes.object
};
